import { Box, Checkbox, FormControlLabel, Modal, Typography } from '@mui/material';
import { useGetBusinesses } from 'apis/agency/hook';
import { useConfigureIntegration, useGetAvailableIntegration } from 'apis/agency/integrations/hook';
import Button from 'components/Common/Button';
import Search from 'components/Common/Search';
import Spinner from 'components/Common/Spinner';
import { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

export default function Configure() {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<null | string>(null);
  const { data: businesses, isLoading } = useGetBusinesses({ page: 1, filter: { account_status_eq: true } });
  // Todo : Add infiniteScroll here
  const { mutateAsync: configureIntegration } = useConfigureIntegration();
  const { data: integration, isLoading: isIntegrationLoading } = useGetAvailableIntegration();

  const [checkedItems, setCheckedItems] = useState<number[]>(integration?.business_ids ?? []);

  const handleCheckboxChange = (knowledgeBaseId: number) => {
    setCheckedItems((prev) =>
      prev.includes(knowledgeBaseId) ? prev.filter((itemId) => itemId !== knowledgeBaseId) : [...prev, knowledgeBaseId]
    );
  };

  const handleCloseModal = () => navigate(-1);

  const handleConfigureIntegration = async () => {
    const payload = {
      business_ids: checkedItems
    };
    await configureIntegration(payload);
    handleCloseModal();
  };

  if (isLoading || isIntegrationLoading) {
    return <Spinner />;
  }
  return (
    <Modal
      open={true}
      onClose={() => handleCloseModal()}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box display='flex' justifyContent='space-between' alignItems='start' mb={2}>
          <Box>
            <Typography variant='body1' fontWeight={600}>
              Select Sub-Account
            </Typography>
            <Typography variant='body2' color='#777'>
              To continue with app installation
            </Typography>
          </Box>
          <Box sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
            <IoClose />
          </Box>
        </Box>
        <Search fullWidth label='Search sub-Account' searchText={searchText} setSearchText={setSearchText} />
        <Box mt={2} sx={{ maxHeight: 300, overflowY: 'auto' }}>
          {businesses?.data?.map((item, index) => (
            <Box key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    name={item.name}
                    value={item.id}
                    checked={checkedItems.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                }
                label={
                  <>
                    {item.name}
                    <div>{item.address?.city}</div>
                  </>
                }
              />
            </Box>
          ))}
        </Box>
        <Box display='flex' justifyContent='flex-end' gap={2}>
          <Button color='secondary' variant='outlined' onClick={() => handleCloseModal()}>
            Cancel
          </Button>
          <Button onClick={() => handleConfigureIntegration()}>Submit</Button>
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  width: {
    xs: '90%',
    sm: 400,
    md: 600,
    lg: 800
  }
};
